import React from 'react';
import {checkComparisonAnswer} from './lib/inequality.js';

export default class CheckAnswer extends React.Component {

  constructor(props) {
    super(props);
  }

  handleUpdatingAnswer(){
    var isAnswerCorrect = checkComparisonAnswer(this.props.leftNumber, 
                                                this.props.rightNumber, 
                                                this.props.equalitySymbol);
    this.props.answerStatus(isAnswerCorrect);
  }

  render() {
    return (
      <div className="inequality-check-answer">
        <button type="button" className="button button--cornflower"
          onClick={() => this.handleUpdatingAnswer()}> 
          Check Answer
        </button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/inequality/check_answer.js
 **/